import { render } from "./CreateCategory.vue?vue&type=template&id=19c827d8"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__